
export const scuba3sHistoricalData = [
  {
    date: '2024-01-15',
    time: '08:00',
    scuba_alkalinity: 120,
    scuba_bromine: 3.5,
    scuba_chlorine: 2.5,
    scuba_copper: 0.8,
    scuba_cya: 45,
    scuba_hardness: 250,
    scuba_phosphate: 0.5,
    scuba_oxygen: 5.2,
    scuba_ph: 7.2,
    technician: 'María García'
  },
  {
    date: '2024-01-14',
    time: '08:00',
    scuba_alkalinity: 115,
    scuba_bromine: 3.8,
    scuba_chlorine: 2.8,
    scuba_copper: 0.7,
    scuba_cya: 48,
    scuba_hardness: 245,
    scuba_phosphate: 0.6,
    scuba_oxygen: 5.5,
    scuba_ph: 7.3,
    technician: 'Carlos López'
  },
  {
    date: '2024-01-13',
    time: '08:00',
    scuba_alkalinity: 125,
    scuba_bromine: 3.2,
    scuba_chlorine: 2.3,
    scuba_copper: 0.9,
    scuba_cya: 42,
    scuba_hardness: 255,
    scuba_phosphate: 0.4,
    scuba_oxygen: 4.8,
    scuba_ph: 7.1,
    technician: 'María García'
  },
  {
    date: '2024-01-12',
    time: '08:00',
    scuba_alkalinity: 118,
    scuba_bromine: 4.0,
    scuba_chlorine: 3.0,
    scuba_copper: 0.6,
    scuba_cya: 50,
    scuba_hardness: 240,
    scuba_phosphate: 0.7,
    scuba_oxygen: 5.8,
    scuba_ph: 7.4,
    technician: 'Ana Martín'
  },
  {
    date: '2024-01-11',
    time: '08:00',
    scuba_alkalinity: 122,
    scuba_bromine: 3.6,
    scuba_chlorine: 2.6,
    scuba_copper: 0.85,
    scuba_cya: 46,
    scuba_hardness: 248,
    scuba_phosphate: 0.55,
    scuba_oxygen: 5.0,
    scuba_ph: 7.25,
    technician: 'Carlos López'
  },
  {
    date: '2024-01-10',
    time: '08:00',
    scuba_alkalinity: 128,
    scuba_bromine: 3.3,
    scuba_chlorine: 2.4,
    scuba_copper: 0.75,
    scuba_cya: 44,
    scuba_hardness: 252,
    scuba_phosphate: 0.48,
    scuba_oxygen: 5.3,
    scuba_ph: 7.15,
    technician: 'María García'
  },
  {
    date: '2024-01-09',
    time: '08:00',
    scuba_alkalinity: 112,
    scuba_bromine: 3.9,
    scuba_chlorine: 2.9,
    scuba_copper: 0.65,
    scuba_cya: 52,
    scuba_hardness: 238,
    scuba_phosphate: 0.62,
    scuba_oxygen: 5.6,
    scuba_ph: 7.35,
    technician: 'Ana Martín'
  }
];
